/**
 * Cliente REST de los MODELOS DE CALIFICACIÓN (grupo E). Los modelos se LEEN
 * local-first (sync `academy_org`), pero se ESCRIBEN por REST (config de admin;
 * authz owner/org_admin ∥ admin de plataforma en el handler). Mismo patrón de
 * auth cookie-BFF que el resto de clientes server-only (metrics/CRM/billing).
 */
import type { GradingLetterBand, GradingModelKind } from "@space/shared";
import { apiJson } from "@/lib/rest";

const BASE = "/api/academy";

/** Cuerpo de creación/edición (fracción 0..1 para el umbral). */
export interface GradingModelInput {
  name?: string;
  kind?: GradingModelKind;
  max_value?: number;
  passing_threshold?: number;
  decimals?: number;
  letter_bands?: GradingLetterBand[] | null;
  display_suffix?: string | null;
  clone_from?: string;
}

function orgUrl(orgId: string): string {
  return `${BASE}/${encodeURIComponent(orgId)}/grading-models`;
}

export function createGradingModel(orgId: string, input: GradingModelInput) {
  return apiJson<unknown>(orgUrl(orgId), { method: "POST", body: JSON.stringify(input) });
}

export function updateGradingModel(orgId: string, modelId: string, input: GradingModelInput) {
  return apiJson<unknown>(`${orgUrl(orgId)}/${encodeURIComponent(modelId)}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export async function deleteGradingModel(orgId: string, modelId: string): Promise<void> {
  await apiJson<unknown>(`${orgUrl(orgId)}/${encodeURIComponent(modelId)}`, { method: "DELETE" });
}
